import type { ReactNode } from "react";
import * as SheetPrimitive from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";
import { Sheet, SheetOverlay, SheetPortal, SheetTitle } from "@/components/ui/sheet";

interface MobileSidebarDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  children: ReactNode;
}

const CONTENT_CLASS = cn(
  "fixed inset-y-0 left-0 z-50 flex h-full w-[304px] max-w-full font-dm shadow-lg transition ease-in-out lg:hidden",
  "data-[state=open]:animate-in data-[state=open]:slide-in-from-left data-[state=open]:duration-500",
  "data-[state=closed]:animate-out data-[state=closed]:slide-out-to-left data-[state=closed]:duration-300",
);

/**
 * Drawer mobile do sidebar (figma-spec §8, S16): 304 px à esquerda, overlay navy-dark 55%.
 * Montado com as peças do Sheet do shadcn para usar o overlay do Figma e o botão fechar do próprio sidebar.
 * Fecha no overlay e com Esc (Radix Dialog); o fechamento ao navegar fica no AppLayout.
 */
export function MobileSidebarDrawer({ open, onOpenChange, title, children }: MobileSidebarDrawerProps) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetPortal>
        <SheetOverlay className="bg-tr-navy-dark/55 lg:hidden" />
        <SheetPrimitive.Content aria-describedby={undefined} className={CONTENT_CLASS}>
          <SheetTitle className="sr-only">{title}</SheetTitle>
          {children}
        </SheetPrimitive.Content>
      </SheetPortal>
    </Sheet>
  );
}
